import React, { useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { TopBar } from "../common/TopBar";
import { URLS } from "../../constants/constants";
import { GetImages } from "../../utils/GetImages";
import apiHelper from "../../utils/apiHelper";
import AddButtonWithArrow from "../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import PasswordField from "../../newComponents/form-fields/PasswordField";
import "./LoginStyles.css";

interface SetPasswordFormValues {
  password: string;
  confirmPassword: string;
}

export const SetPassword: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState<string | null>(null);

  const methods = useForm<SetPasswordFormValues>({
    mode: "onBlur",
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
  });

  const { handleSubmit } = methods;

  const onSubmit = async (data: SetPasswordFormValues) => {
    setLoading(true);
    setApiError(null);

    try {
      // Real API call - apne actual service/endpoint se replace kar dena
      // const response = await apiHelper(
      //   AuthService.postApiSetPassword,
      //   { showNotification: true },
      //   {
      //     password: data.password,
      //     token: state?.token,
      //     email: state?.email,
      //   }
      // );

      // Temporary success simulation
      alert("Password set successfully! You can now log in.");
      navigate(URLS.LOGIN);
    } catch (err: any) {
      setApiError(err?.message || "Failed to set password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="background-section background-image">
      <TopBar haveAccount="Already have an account?" signInUp="Log in" />

      <div className="form-container-main">
        <div className="loginFormWrapper">
          <p className="login_header black mb-4">Set Your Password</p>

          {apiError && (
            <div className="alert alert-danger mb-3">{apiError}</div>
          )}

          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <div className="mt-3">
                <PasswordField
                  name="password"
                  label="New Password"
                  placeholder="Enter new password"
                  required
                  requiredMessage="Password is required"
                  allowSpecialChars
                />
              </div>

              <div className="mt-4">
                <PasswordField
                  isConfirmPassword
                  name="confirmPassword"
                  label="Confirm Password"
                  placeholder="Re-enter password"
                  required
                  requiredMessage="Confirm password is required"
                  allowSpecialChars
                />
              </div>

              <div className="mt-4">
                <AddButtonWithArrow
                  className="loginButton sub_heading w-100"
                  type="submit"
                  buttonname="Set Password"
                  disabled={loading}
                  loading={loading}
                />
              </div>
            </form>
          </FormProvider>

          <div className="mt-4 text-center">
            <p
              className="normal_text fw-600 blue cursor-pointer"
              onClick={() => navigate(URLS.LOGIN)}
            >
              Back to Login
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};